const EMAIL_PATTERN = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/
const PHONE_PATTERN = /^[0-9+().\-\s]{6,40}$/
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export const cleanText = (value: unknown, max: number): string => {
    if (typeof value !== 'string') return ''

    return value.replace(/\r\n/g, '\n').trim().slice(0, max)
}

export const cleanLine = (value: unknown, max: number): string =>
    cleanText(value, max).replace(/\s+/g, ' ')

export const isEmail = (value: string): boolean =>
    value.length <= 254 && EMAIL_PATTERN.test(value)

export const isPhone = (value: string): boolean =>
    PHONE_PATTERN.test(value) && /\d{6,}/.test(value.replace(/\D/g, ''))

export const isIsoDate = (value: string): boolean => {
    if (!DATE_PATTERN.test(value)) return false

    const date = new Date(`${value}T00:00:00Z`)

    return !Number.isNaN(date.getTime()) && date.toISOString().startsWith(value)
}

export const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
